/**
 * author: Qian.qianchen 2019-02-27
 * description: 来源编辑
 */
'use strict';
angular.module("sourceEditModule", [])
    .controller("sourceEditCtrl", ['$scope', "$modalInstance", '$validation', 'trsHttpService', 'modalDialog', 'item', function($scope, $modalInstance, $validation, trsHttpService, modalDialog, item) {
        initStatus();
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            $validation.validate($scope.typingForm).success(function() {
                var params = {
                    "serviceid": "mlf_personalsource",
                    "methodname": "savePersionalSource",
                    "sourceId": angular.isDefined(item) ? item.SOURCEID : '',
                    "srcname": $scope.data.sourceName,
                    "srcdesc": $scope.data.sourceDesc
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    if (data.ISSUCCESS) {
                        modalDialog.alertType('', angular.isDefined(item) ? "编辑来源成功" : "新建来源成功", 'success', false);
                        $modalInstance.close('success');
                    }
                });
            });
        };
        /**
         * [initStatus description] 数据初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                title: angular.isDefined(item) ? "编辑来源" : "添加来源"
            };
            $scope.data = {
                sourceName: angular.isDefined(item) ? item.SRCNAME : "",
                sourceDesc: angular.isDefined(item) ? item.SRCDESC : "",
            }
        }
    }]);